<template>
  <div class="calendar">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>行事曆</p>
    </div>
    <el-form>
      <el-form-item label='活動名稱:'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="calendar.activityName" placeholder="請輸入活動名稱">
      </el-form-item>

      <el-form-item label="活動日期:">
        <el-date-picker format='yyyy-MM-dd HH:mm' v-model="calendar.activityDate" type="datetime"
                        placeholder="選擇時間"></el-date-picker>
      </el-form-item>

      <el-form-item label='活動地點:'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="calendar.activityPlace" placeholder="請輸入活動地點">
      </el-form-item>

      <el-form-item label='活动类型:'>
        <el-select v-model="calendar.type" placeholder="請選擇活動類型">
          <el-option label="林距離" :value="1"></el-option>
          <el-option label="其他" :value="9"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label='關聯新聞/活動:'>
        <el-radio-group v-model="calendar.activityRelated" @change="changeRelation">
          <el-radio :label="'2'">新聞</el-radio>
          <el-radio :label="'1'">活動</el-radio>
          <el-radio :label="''">不關聯</el-radio>
        </el-radio-group>
        <div v-if="calendar.activityRelated === '1' || calendar.activityRelated === '2'">
          <el-input placeholder="請輸入文章/活動ID" :disabled="relatedSuccess" type="text"
                    v-model="calendar.relatedId"></el-input>
          <div class="btn" style="display: inline-block;text-align: center" @click="relatedActivity">
            {{ relatedSuccess ? '取消關聯' : '關聯' }}
          </div>
          <div class="relatedTip" @click="getArticleId">如何獲取關聯ID？</div>
        </div>
      </el-form-item>


      <el-form-item label="上傳主圖:" class="picupload">
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials="true"
          :on-remove="handleRemove"
          :on-error='$errorImage'
          :file-list="fileList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="$beforePicUpload.bind(this,0,20)"
          :limit=1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name='multipartFile'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div class="bottomBtn">
      <div class="btn" @click="submitContent()">發佈</div>
    </div>

    <prop-wrap v-if="showGetIdWay" :title="'如何獲得新聞/活動ID'" :width="'9rem'" :height="'6.1rem'"
               v-on:closeProp="closePropWrap">
      <div class="propContent">
        <span>進入新聞/活動列表，找到表頭ID列，複製文章對應ID即可</span>
        <img src="../assets/images/common/id_tip_img.png" alt="">
      </div>
    </prop-wrap>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
import PropWrap from "./propWrap";

export default {
  props: ['type', 'id'],
  data() {
    return {
      calendar: {
        activityName: '',
        activityDate: '',
        activityPlace: '',
        type: '',
        activityRelated: '',
        relatedId: '',
        linkId: '',
        linkName: '',
      },
      vipType: '',
      fileList: [],
      dialogVisible: false,
      relatedSuccess: false,
      showGetIdWay: false
    }
  },
  created() {
    let _this = this;
    if (_this.type === 'edit') {
      _this.initCalendar();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 编辑行事历，查询详情
    initCalendar() {
      let _this = this;
      _this.$get(`/calendar/activity/${_this.id}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.calendar = {
              activityName: res.data.calendarName,
              activityDate: res.data.calendarTime,
              activityPlace: res.data.calendarAddress,
              type: res.data.type,
              activityRelated: res.data.linkType === null ? '' : res.data.linkType.toString(),
              relatedId: res.data.linkName,
              linkId: res.data.linkId,
              linkName: res.data.linkName,
            }
            _this.vipType = res.data.vipType
            if (res.data.linkType !== '') {
              _this.relatedSuccess = true
            }
            _this.fileList.push({name: 'img.jpg', url: res.data.calendarImg});
            document.getElementsByClassName('el-upload')[0].style.display = 'none';
          } else {
            _this.$propMessage(res.message, 'error');
          }
        });
    },

    // 移除图片的回调函数
    handleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.fileList)
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
    },

    uploadRequest(option) {
      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        const fileWay = 'resource/image/'
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {headers: {'Cache-Control': 'public'}})
            .then((val) => {
              if (val.res.statusCode === 200) {
                self.fileList.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl + val.name})
                console.log('图片路径++' + self.fileList[0].url)
                //cdn预热
                self.$cdnFun(self.fileList[0].url).then(res => {
                  console.log(res)
                })
                document.getElementsByClassName('el-upload')[0].style.display = 'none';
                return val
              } else {
                option.onError('上传失败')
              }
            }, err => {
              console.log(err)
              option.onError('上传失败')
              reject(err)
            })
        })
      })
    },

    // 上传列表发生变化的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    // 提交内容
    submitContent() {
      let _this = this;
      if (_this.calendar.activityName === '' || _this.$getCaption(_this.calendar.activityName)) {
        _this.dialogVisible = true;
        _this.$propMessage('活動名稱不能為空或者含有非法字符！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.calendar.activityDate === '') {
        _this.dialogVisible = true;
        _this.$propMessage('活動日期不能為空！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.calendar.activityPlace === '' || _this.$getCaption(_this.calendar.activityPlace)) {
        _this.dialogVisible = true;
        _this.$propMessage('活動地點不能為空或者含有非法字符！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.calendar.type === '') {
        _this.dialogVisible = true;
        _this.$propMessage('活動類型不能為空！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.calendar.activityRelated !== '') {
        if (_this.calendar.relatedId === '') {
          _this.dialogVisible = true;
          _this.$propMessage('關聯新聞/活動不能為空！', 'error', function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (!_this.relatedSuccess) {
          _this.dialogVisible = true;
          _this.$propMessage('新聞/活動未關聯！', 'error', function () {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (_this.fileList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('主圖不能為空！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      // 新增行事历提交
      if (_this.type === 'add') {
        let param = {
          calendarAddress: _this.calendar.activityPlace,
          calendarImg: _this.fileList[0].url,
          calendarName: _this.calendar.activityName,
          calendarTime: _this.calendar.activityDate,
          type: Number(_this.calendar.type),
          id: '',
          linkId: _this.calendar.linkId,
          linkType: _this.calendar.activityRelated,
          linkName: _this.calendar.linkName
        };
        if (_this.vipType !== '') {
          param['vipType'] = _this.vipType
        }
        console.log(param)
        _this.$post('/calendar/activity', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {

              _this.$propMessage('發佈成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.$router.push('/calendarList')
                });

            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          });
      } else if (_this.type === 'edit') {
        // 编辑行事历提交
        let editParam = {
          calendarAddress: _this.calendar.activityPlace,
          calendarImg: _this.fileList[0].url,
          calendarName: _this.calendar.activityName,
          calendarTime: _this.calendar.activityDate,
          type: Number(_this.calendar.type),
          id: _this.id,
          linkId: _this.calendar.linkId,
          linkType: _this.calendar.activityRelated,
          linkName: _this.calendar.linkName
        };
        if (_this.vipType !== '') {
          editParam ['vipType'] = _this.vipType
        }
        _this.$put('/calendar/activity', editParam, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('發佈成功', 'success', function () {
                _this.dialogVisible = false;
                _this.$router.push('/calendarList')
              });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          });
      }
      ;
    },

    changeRelation() {
      this.relatedSuccess = false
      this.vipType = ''
      this.calendar.linkName = ''
      this.calendar.relatedId = ''
      this.calendar.linkId = ''
    },

    //關聯新聞/活動
    relatedActivity() {
      let _this = this
      if (_this.calendar.relatedId === '') {
        _this.dialogVisible = true;
        _this.$propMessage('ID不能为空！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      var params = {
        "linkId": _this.calendar.relatedId,
        "linkType": _this.calendar.activityRelated
      }
      if (this.relatedSuccess) {
        // 取消關聯
        this.relatedSuccess = false
        this.vipType = ''
        this.calendar.linkName = ''
        this.calendar.relatedId = ''
        this.calendar.linkId = ''
      } else {
        // 關聯
        _this.$post('/calendar/activity/relation', params, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('關聯成功', 'success', function () {
                _this.dialogVisible = false;
                _this.relatedSuccess = true
                _this.calendar.linkId = _this.calendar.relatedId
                _this.calendar.linkName = res.data.linkName
                _this.calendar.relatedId = res.data.linkName
                _this.vipType = res.data.vipType
              });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                  _this.vipType = ''
                  _this.calendar.linkName = ''
                  _this.calendar.relatedId = ''
                  _this.calendar.linkId = ''
                });
            }
          });
      }
    },

    // 如何获取ID
    getArticleId() {
      this.showGetIdWay = true
    },

    closePropWrap(data) {
      this.showGetIdWay = data
    }
  },
  components: {
    PropWrap,
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.relatedTip {
  text-decoration: underline;
  text-underline: #6C3DEA;
  color: #6C3DEA;
  font-size: 14px;
}

.propContent {
  padding: 0.23rem 0.78rem 0 0.78rem;
  text-align: left;
  color: #292929;

  span {
    font-size: 0.14rem;
  }

  img {
    width: 100%;
    margin-top: 0.28rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/calendar.vue